import FieldConfig from "../../../proto/field-config"
import FieldUsers from "../../../generic/users/users"
import FieldProjectUsers_TableCell from "./render/table/table-cell"
import Project from "../../../../model2/project/project"
import {
    FieldProjectUsers_filterFunc,
    FieldProjectUsers_filterValuesFiller
} from "../../../conditions/dropdown"
import FieldProjectUsers_ConditionForm from "./render/condition"
import Filter from "../../../../manager/filters/manager/filter"
import {
    FieldProjectUsers_filterGetOptions
} from "../../../conditions/functions/get-filter-options"
import {ConditionType_ArrayIntersection, ConditionType_ArrayNonIntersection} from "../../../../model2/conditions/condition-types"

export default class FieldProjectUsers extends FieldUsers {

    constructor(config:FieldConfig) {
        super(config);

        this.icon       = 'i5-users'
        this.label      = 'All users'
        this.showConditionsNotSetOption = false

        this.conditionTypes                 = [ConditionType_ArrayIntersection, ConditionType_ArrayNonIntersection]

        this.renderComponents.tableCell     = FieldProjectUsers_TableCell

        this.renderComponents.conditionForm = FieldProjectUsers_ConditionForm
        this.renderComponents.filterForm    = FieldProjectUsers_ConditionForm

        this.filterFunc                     = FieldProjectUsers_filterFunc
        this.filterValuesFiller             = FieldProjectUsers_filterValuesFiller
    }

    canEdit(model:Project):boolean {
        return model.acl.canChangeUsers
    }

    async filterGetOptions(filter: Filter): Promise<Option[]> {
        return await FieldProjectUsers_filterGetOptions(this, filter)
    }
}
